import { createTokenDecimals } from '@lfg/core/lib';

import { APP_ENV } from '@/global/configs/common.config';

const decimals = createTokenDecimals(APP_ENV);
export const { GALA_DECIMAL, USDC_DECIMAL, USDT_DECIMAL, ETH_DECIMAL, BSC_DECIMAL, USD_VALUE_DECIMAL } = decimals;
